const TechnologyLookup = require('./TechnologyLookup');
const Common = require('./Common');

module.exports = {
    TechnologyLookup,
    GetIncreasePopulationCost: Common.GetIncreasePopulationCost,
    GetConsumption: Common.GetConsumption,
    GetCorruption: Common.GetCorruption,
    GetCardRowCost: Common.GetCardRowCost,
    GetCardRowRemovalCount: Common.GetCardRowRemovalCount,
    GetRequiredHappyFaces: Common.GetRequiredHappyFaces,
}
